module.exports = __webpack_public_path__ + "media/images/emblems/RivaSanVitale-coat_of_arms-892939a62fb14cde242b79f4daa9f6b3.svg";